<template lang="html">
  <div class="tab">
    <div class="">
      <div class="logo-box">
        <img src="~common/pc/images/logo.png" alt="因他科技" title="因他科技">
      </div>
      <div class="nav-wrap" ref="navWrap">
        <div class="nav-box">
          <router-link v-for="(item, index) in navData" :key="index" class="tab-item" tag="div" :to="item.url" @click="changeNav(item.children.length)">
            <span class="tab-link">{{item.tabName}}</span>
            <ul v-if="item.children.length" class="sub-tab">
              <li v-for="(inItem, inIndex) in item.children" :key="index + inIndex">
                <router-link class="sub-t-item" tag="div" to="">
                  <span class="sub-t-link" @click="blankTargt(inItem.url)">{{inItem.tabName}}</span>
                </router-link>
              </li>
            </ul>
          </router-link>
          <!-- <router-link class="tab-item" tag="div" to="/produce">
            <span class="tab-link">产品中心</span>
          </router-link>
          <router-link class="tab-item" tag="div" to="/server">
            <span class="tab-link">微服务</span>
          </router-link>
          <router-link class="tab-item" tag="div" to="/aboutUs">
            <span class="tab-link">关于我们</span>
          </router-link>
          <router-link class="tab-item" tag="div" to="/partner">
            <span class="tab-link">合作伙伴</span>
            <ul class="sub-tab">
              <li>
                <router-link class="sub-t-item" tag="div" to="">
                  <span class="sub-t-link" @click="blankTargt">福音影视</span>
                </router-link>
              </li>
              <li>
                <router-link class="sub-t-item" tag="div" to="">
                  <span class="sub-t-link" @click="blankTargt">赞美诗网</span>
                </router-link>
              </li>
              <li>
                <router-link class="sub-t-item" tag="div" to="">
                  <span class="sub-t-link" @click="blankTargt">引程人力网</span>
                </router-link>
              </li>
            </ul>
          </router-link> -->
        </div>
      </div>
      <div class="nav-icon">
        <i class="icon iconfont icon-gengduo2" @click="openNav"></i>
      </div>
    </div>
  </div>
</template>

<script>
import navData from 'json/pc/header.json'
export default {
  data () {
    return {
      isOpen: false,
      navData: []
    }
  },
  mounted () {
    this.navData = navData
  },
  methods: {
    changeNav (flag) {
      console.log(flag)
      if (!flag) {
        this.openNav()
      }
    },
    blankTargt (url) {
      window.open(url)
    },
    openNav () {
      if (!this.isOpen) {
        this.$refs.navWrap.style.display = 'block'
      } else {
        this.$refs.navWrap.style.display = 'none'
      }
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/pc/stylus/base'
.tab
  width: 100%
  position: fixed
  z-index: 999
  background-color: #fff
  padding: 30px 20px 0
  color: #333
  &>div
    max-width: 1400px
    margin: auto
.logo-box, .tab-item
  display: inline-block
.logo-box
  img
    height: 40px
    vertical-align: middle
.nav-wrap
  float: right
.nav-box
  font-size: 18px
  .tab-item
    position: relative
    cursor: pointer
    padding: 10px 10px 20px
    margin-right: 30px
    transition: .2s
    &:hover
      .sub-tab
        width: 100%
        display: block
        animation: subtab 0.3s ease
        margin-left: -10px
      /* &>span
        color: #007CE5 */
      &:after
        content: ''
        width: 100%
        height: 6px
        position: absolute
        left: 0
        bottom: 0
        background-color: #007CE5
        border-radius: 1px
  &>.router-link-exact-active
    &>span
      color: #007CE5
    &:after
      content: ''
      width: 100%
      height: 6px
      position: absolute
      left: 0
      bottom: 0
      background-color: #007CE5
      border-radius: 1px
.sub-tab
  position: absolute
  top: 50px
  display: none
  font-size: 16px
  color: #333
  text-align: center
  li
    padding: 10px 0
    background-color: #F5F5F5
    &:hover
      background-color: #DDDDDD
.nav-icon
  display: none

@keyframes subtab {
  0% {
    transform: translateY(-20px);
    opacity: 0
  }
  100% {
    transform: translateY(0);
    opacity: 1
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/header/header.vue